import Phaser from 'phaser';

/**
 * Прыгающий жук-«лягушка». На земле выжидает короткий cooldown, потом
 * прыгает в сторону героя, если тот в патрульных границах. Внутри patrolMin
 * /patrolMax удерживается принудительно — не сваливается в ямы за их
 * пределами. На платформах не появляется (внешним кодом).
 */
export class EnemyHopper extends Phaser.Physics.Arcade.Sprite {
  private hp = 16;
  private hurtTimer = 0;
  private dying = false;
  private hopCooldown = 0;
  private patrolMin: number;
  private patrolMax: number;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    patrolMin: number,
    patrolMax: number,
  ) {
    super(scene, x, y, 'enemy-hopper-hq');
    scene.add.existing(this);
    scene.physics.add.existing(this);
    // HQ-painterly спрайт. Видимый объём — лягушка-стимпанк сопоставима с
    // героем (80×104), bодy чуть меньше визуала.
    this.setDisplaySize(96, 84);

    this.patrolMin = patrolMin;
    this.patrolMax = patrolMax;

    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setSize(64, 56);
    body.setMaxVelocity(400, 1000);
    body.setDragX(160);
  }

  override preUpdate(time: number, delta: number) {
    super.preUpdate(time, delta);
    if (this.dying) return;
    this.hurtTimer = Math.max(0, this.hurtTimer - delta);
    this.hopCooldown = Math.max(0, this.hopCooldown - delta);

    const body = this.body as Phaser.Physics.Arcade.Body;

    // Не даём улететь за патрульные границы — мягко возвращаем
    if (this.x < this.patrolMin && body.velocity.x < 0) {
      body.setVelocityX(0);
      this.x = this.patrolMin;
    }
    if (this.x > this.patrolMax && body.velocity.x > 0) {
      body.setVelocityX(0);
      this.x = this.patrolMax;
    }
  }

  /** Вызывается из GameScene каждый кадр с координатой героя. */
  considerHop(playerX: number, playerOnScreen: boolean) {
    if (this.dying || this.hurtTimer > 0) return;
    if (!playerOnScreen) return;
    if (this.hopCooldown > 0) return;
    const body = this.body as Phaser.Physics.Arcade.Body;
    const onGround = body.blocked.down || body.touching.down;
    if (!onGround) return;

    // Прыгаем в сторону героя, но не за патрульные границы
    let dir: 1 | -1;
    if (playerX > this.x && this.x < this.patrolMax - 20) dir = 1;
    else if (playerX < this.x && this.x > this.patrolMin + 20) dir = -1;
    else return;

    body.setVelocity(dir * 220, -480);
    this.setFlipX(dir === -1);
    this.hopCooldown = 1100 + Math.random() * 400;
  }

  takeDamage(amount: number, knockbackX: number) {
    if (this.dying) return;
    this.hp -= amount;
    this.hurtTimer = 220;
    this.setTintFill(0xffffff);
    this.scene.time.delayedCall(80, () => {
      if (this.active && !this.dying) this.clearTint();
    });
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setVelocityX(knockbackX);
    body.setVelocityY(-200);
    if (this.hp <= 0) this.die();
  }

  private die() {
    this.dying = true;
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setEnable(false);
    this.scene.tweens.add({
      targets: this,
      alpha: 0,
      scaleX: 0.5,
      scaleY: 0.5,
      duration: 280,
      onComplete: () => this.destroy(),
    });
  }

  isAlive() {
    return !this.dying && this.active;
  }
}
